/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendApplicationToSigner_requestSignature_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string };

export type SendApplicationToSigner_Mutation = { readonly __typename: 'Mutation', readonly requestSignature: SendApplicationToSigner_requestSignature_CreditApplication };


export type SendApplicationToSignerVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type SendApplicationToSigner = SendApplicationToSigner_Mutation;


export const SendApplicationToSignerDocument = gql`
    mutation SendApplicationToSigner($creditApplicationId: ID!) {
  requestSignature(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
  }
}
    `;
export type SendApplicationToSignerMutationFn = Apollo.MutationFunction<SendApplicationToSigner, SendApplicationToSignerVariables>;

/**
 * __useSendApplicationToSigner__
 *
 * To run a mutation, you first call `useSendApplicationToSigner` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendApplicationToSigner` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendApplicationToSigner, { data, loading, error }] = useSendApplicationToSigner({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useSendApplicationToSigner(baseOptions?: Apollo.MutationHookOptions<SendApplicationToSigner, SendApplicationToSignerVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendApplicationToSigner, SendApplicationToSignerVariables>(SendApplicationToSignerDocument, options);
      }
export type SendApplicationToSignerHookResult = ReturnType<typeof useSendApplicationToSigner>;
export type SendApplicationToSignerMutationResult = Apollo.MutationResult<SendApplicationToSigner>;
export type SendApplicationToSignerMutationOptions = Apollo.BaseMutationOptions<SendApplicationToSigner, SendApplicationToSignerVariables>;